import React, { FC, useContext, useState } from "react";
import { Snackbar, SnackbarContent } from '@mui/material';
import AlertStyles from './alert.module.scss';

interface AlertProps {
    message: string;
}

const Alert: React.FC<AlertProps> = ({ message }) => {
    return (
        <div className={AlertStyles.message}>{message}</div>
    );
}

const PopupContext = React.createContext<(message: string, type: "error" | "msg") => void>((message: string, type: "error" | "msg") => { });

interface Props {
    children: React.ReactNode;
}

export const AlertProvider: FC<Props> = ({ children }) => {
    const [open, setOpen] = React.useState(false);
    const [text, setText] = useState<string>("");
    const [type, setType] = useState<string>("");

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    function alert(message: string, type: "error" | "msg") {
        setText(message);
        setType(type)
        setOpen(true);
    }

    return (
        <PopupContext.Provider value={alert}>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <SnackbarContent
                    classes={{ root: AlertStyles.snackContainer }}  // Use 'classes' instead of 'className'
                    style={{ backgroundColor: (type === "error" ? "#c72c2c" : "#31d91e") }}
                    message={<Alert message={text} />}
                />
            </Snackbar>
            {children}
        </PopupContext.Provider>
    );
};

export function useAlert() {
    const alert = useContext(PopupContext);
    return alert;
}
